export function normalizeQuickMessageShortcut(value = "") {
  return String(value)
    .trim()
    .replace(/^\/+/, "")
    .toLowerCase()
    .replace(/\s+/g, "_");
}

export function getQuickMessageTrigger(value = "", caret = value.length) {
  const safeValue = String(value);
  const safeCaret = Math.max(0, Math.min(caret, safeValue.length));
  const beforeCaret = safeValue.slice(0, safeCaret);
  const slashIndex = beforeCaret.lastIndexOf("/");

  if (slashIndex < 0) return null;
  if (slashIndex > 0 && /\S/.test(beforeCaret[slashIndex - 1])) return null;

  const token = beforeCaret.slice(slashIndex + 1);
  if (!token || /\s/.test(token)) return null;

  return {
    query: normalizeQuickMessageShortcut(token),
    start: slashIndex,
    end: safeCaret,
  };
}

export function filterQuickMessages(rows = [], query = "") {
  const normalizedQuery = normalizeQuickMessageShortcut(query);

  return rows.filter((row) =>
    normalizeQuickMessageShortcut(row?.shortcut ?? "").startsWith(normalizedQuery)
  );
}

export function applyQuickMessageSelection(value = "", selection) {
  const templateBody = String(selection?.template_body ?? "");
  const start = Math.max(0, Number(selection?.start ?? 0));
  const end = Math.max(start, Number(selection?.end ?? start));
  const nextValue =
    String(value).slice(0, start) +
    templateBody +
    String(value).slice(end);

  return {
    value: nextValue,
    caret: start + templateBody.length,
  };
}

export function buildQuickMessageInsertPayload(clinicId, values = {}) {
  return {
    praticien_id: String(clinicId ?? ""),
    template_kind: "quick_message",
    shortcut: normalizeQuickMessageShortcut(values.shortcut),
    name: "",
    display_name: String(values.display_name ?? "").trim(),
    chakra_template_name: "",
    template_body: String(values.template_body ?? "").trim(),
    placeholders: [],
    language_code: "",
    content_sid: "",
    header_media_url: "",
  };
}

export function buildQuickMessageUpdatePayload(values = {}) {
  return {
    template_kind: "quick_message",
    shortcut: normalizeQuickMessageShortcut(values.shortcut),
    display_name: String(values.display_name ?? "").trim(),
    template_body: String(values.template_body ?? "").trim(),
  };
}
